/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { useEffect, useMemo, useState } from 'react'
import { Modal } from 'shared'
import ModalDonateNftStyled from './styled'
import { notification } from 'antd'
import Button from 'shared/Button'
import { CLOSE_BTN, LINE_GUILD_GRADIENT, TWO_LINE } from 'assets/images'
import { useTranslation } from 'react-i18next'
import { GUILD_MESSAGE, LENDING_MESSAGE, NOTIFICATION_MESSAGE } from 'i18n/constants'
import { NUMBER, STATUS_TRANSACTION, STRING, timeCheckNonce } from 'apps/constants'
import { useAvailableWallet } from 'features/Auth/pages/Main/useAvailableWallet'
import { ethers } from 'ethers'
import { checkAnyWalletEnabled, convertGasPrice, getGasPriceOption, handleAsyncRequest, removeDataAtLocalStorage } from 'utils/helper'
import guildApi from 'apis/guildApi'
import { useAppDispatch, useAppSelector, useReloadCurrentPage, useToggle, useUpdateEffect } from 'hooks'
import { configs, links } from 'apps'
import guildVaultABI from 'json/GuildVault.json'
import { BigNumber } from 'ethers'
import InProgressBalanceModal from 'features/Balance/components/InProgress'
import itemApi from 'apis/itemApi'
import { GetRaceListParams } from 'models'
import { RaceTable } from 'features/Race/components'
import { guildWeaponColumns } from 'utils/columns'
import ReactPaginate from 'react-paginate'
import itemNFTABI from 'json/ItemNFT.json'
import { getNftList } from 'apps/redux/userCreateRace/action'
import { useNavigate } from 'react-router-dom'
import ModalConfirm from 'features/Guild/components/ModalConfirmEditGuild'

interface ModalProps {
  toggleIsModalOpen: (value?: boolean) => void
  onCloseButtonClick: () => void
  onConfirmDonate: () => void
}

interface ResultDonate {
  adil_amount: number
  block_expired: number
  gas_price: number
  guild_id: number
  item_ids: number[]
  nonce: string
  ticket_amounts: number[]
  ticket_ids: number[]
  r: string
  s: string
  v: number
}

interface RequestDonate {
  guildId: string
  blockExpired: string
  itemIds: number[] | null
  ticketIds: string[] | null
  ticketAmounts: string[] | null
  adilAmount: BigNumber
  nonce: string | null
  r: string
  s: string
  v: number
}

const contract = {
  tokenGuildVault: configs.guildVault
}

const defaultParams: GetRaceListParams = {
  limit: NUMBER.TWENTY,
  page: NUMBER.ONE
}

export default function DonateNft({ onCloseButtonClick, onConfirmDonate }: ModalProps) {
  const [api, contextHolder] = notification.useNotification()
  const [loadingSubmit, setLoadingSubmit] = useState(false)
  const { t } = useTranslation()
  const { profile } = useAppSelector(state => state)
  const [openInProgressBalanceModal, toggleOpenInProgressBalanceModal] = useToggle(false)
  const [dataItems, setDataItems] = useState<any>([])
  const [params, setParams] = useState<GetRaceListParams>(defaultParams)
  const [loading, setLoading] = useState<boolean>(false)
  const [total, setTotal] = useState()
  const [tokenIds, setTokenIds] = useState<number[]>([])
  const dispatch = useAppDispatch()
  const navigate = useNavigate()
  const [isConfirm, setIsConfirm] = useState(false)
  const [isConfirmMulti, setIsConfirmMulti] = useState(false)

  const providers = useAvailableWallet()
  const storedWalletName = localStorage.getItem('walletName')

  const matchedProviderDetail = providers.find(p => p.info.name === storedWalletName)
  const ethereumProvider = matchedProviderDetail?.provider ?? window.ethereum
  const provider = new ethers.providers.Web3Provider(ethereumProvider)
  const signer = provider.getSigner()

  useEffect(() => {
    if (profile.guild_id !== NUMBER.ZERO) {
      getListItems()
    }
  }, [params, profile.guild_id])

  const openNotification = (message: string, description: string) => {
    notification.config({
      duration: NUMBER.FOUR
    })
    api.info({
      message,
      description,
      placement: 'bottomRight',
      className: message === STRING.ERROR ? 'ant-custom-error' : 'ant-custom-success'
    })
  }

  const getListItems = async () => {
    setLoading(true)
    const [error, result]: any = await handleAsyncRequest(itemApi.getAllItemsNft(params))
    if (error) {
      openNotification(STRING.ERROR, error.message || error.errors[0]?.message)
    }
    if (result) {
      const formatData = result.data.records.map((record: any, index: number) => {
        return {
          ...record,
          noCustom: (params.page - 1) * params.limit + index + 1,
          avatar: record.img,
          raceName: record.name,
          isSelected: tokenIds.includes(record.item_token)
        }
      })
      setDataItems(formatData)
      setTotal(result.data?.total || NUMBER.ZERO)
    }

    setLoading(false)
  }

  useUpdateEffect(() => {
    setParams({ ...params, page: NUMBER.ONE })
  }, [])

  const memoizedResultListSelectionColumns = useMemo(() => {
    return guildWeaponColumns
  }, [profile])

  const transactionFaild = (value: any) => {
    toggleOpenInProgressBalanceModal(false)
    notification.error({
      message: 'ERROR',
      description: value ?? 'Sorry! Your transaction has failed. Please go back and try again.',
      placement: 'bottomRight',
      duration: 4,
      className: 'ant-custom-error',
      icon: <></>
    })
  }

  const transactionSuccess = () => {
    toggleOpenInProgressBalanceModal(false)
    notification.success({
      message: 'SUCCESS',
      description: `Donate successfully!`,
      placement: 'bottomRight',
      duration: 4,
      className: 'ant-custom-success'
    })
    dispatch(getNftList({ guildId: profile.guild_id, params: defaultParams }))
  }

  const checkNonceContract = async (nonce: string) => {
    let checkNonceExits = null as any
    let x = 0
    const intervalID = setInterval(async () => {
      const [, result] = await handleAsyncRequest(guildApi.postCheckNonceGuildAdil({ nonce }))
      if (!result) return
      checkNonceExits = result.data.status
      if (checkNonceExits === STATUS_TRANSACTION.success) {
        clearInterval(intervalID)
        transactionSuccess()
        onConfirmDonate()
      }

      if (checkNonceExits === STATUS_TRANSACTION.expired) {
        clearInterval(intervalID)
        toggleOpenInProgressBalanceModal(false)
        transactionFaild(t(`${LENDING_MESSAGE}.failedTransaction`))
      }

      if (++x === 10) {
        if (checkNonceExits === STATUS_TRANSACTION.pending) {
          clearInterval(intervalID)
          toggleOpenInProgressBalanceModal(false)
          transactionFaild(t(`${NOTIFICATION_MESSAGE}.transferredPending`))
        }
      }
    }, timeCheckNonce)
  }

  const transactionContract = async (value: ResultDonate) => {
    if (!value) return
    try {
      const ethContract = new ethers.Contract(contract.tokenGuildVault, guildVaultABI.contract.abi, signer)
      try {
        const request: RequestDonate = {
          guildId: value.guild_id.toString(),
          itemIds: value.item_ids,
          ticketIds: [],
          ticketAmounts: [],
          adilAmount: ethers.utils.parseEther(value.adil_amount.toString()),
          blockExpired: value.block_expired.toString(),
          nonce: value.nonce,
          v: value.v,
          r: value.r,
          s: value.s
        }
        const tx = await ethContract.deposit(request)
        if (tx.hash) {
          setLoadingSubmit(false)
          checkNonceContract(value.nonce)
        }
      } catch (err: any) {
        setLoadingSubmit(false)
        transactionFaild(err?.error?.data?.message)
        toggleOpenInProgressBalanceModal(false)
      }
    } catch (err: any) {
      setLoadingSubmit(false)
      transactionFaild(err?.error?.data?.message)
      toggleOpenInProgressBalanceModal(false)
    }
  }

  const approveDonateNft = async (value: ResultDonate) => {
    try {
      if (!signer) return
      const itemNFTContract = new ethers.Contract(configs.itemNFT, itemNFTABI.contract.abi, signer)
      const gasPrice = convertGasPrice(+value.gas_price)
      try {
        const tx = await itemNFTContract.approveBatch(configs.transporter, tokenIds,
          getGasPriceOption(gasPrice)
        )
        if (tx.hash) {
          const resultTransaction = await provider.waitForTransaction(tx.hash)
          if (resultTransaction.status) {
            transactionContract(value)
          } else {
            toggleOpenInProgressBalanceModal(false)
            transactionFaild(t(`${LENDING_MESSAGE}.failedTransaction`))
          }
        }
      } catch (err: any) {
        setLoadingSubmit(false)
        transactionFaild(err?.error?.data?.message)
      }
    } catch (err: any) {
      setLoadingSubmit(false)
      transactionFaild(err?.error?.data?.message)
    }
  }

  const handleConfirmSubmit = async () => {
    setLoadingSubmit(true)
    const payload = {
      item_tokens: tokenIds,
      guild_id: Number(profile?.guild_id)
    }
    const isWalletEnabled = await checkAnyWalletEnabled(storedWalletName as string)
    if (!isWalletEnabled) {
      setLoadingSubmit(false)
      removeDataAtLocalStorage()
      navigate(links.home.index())
      useReloadCurrentPage()
      return
    }
    const [error, result]: any = await handleAsyncRequest(guildApi.postDonateItems(payload))
    if (error) {
      setLoadingSubmit(false)
      return
    }
    if (result) {
      toggleOpenInProgressBalanceModal(true)
      approveDonateNft(result.data)
    }
    // toggleOpenInProgressBalanceModal(true)
    // approveDonateNft()
  }

  const handlePageClick = (event: any) => {
    setParams({ ...params, page: event.selected + 1 })
  }

  const handleSave = () => {
    if (tokenIds?.length === 1) {
      setIsConfirm(true)
    } else {
      setIsConfirmMulti(true)
    }
  }

  return (
    <Modal>
      <ModalDonateNftStyled>
        {contextHolder}
        <div className='donate-coin-modal'>
          <button className='close-btn p-0 position-absolute' role='button' onClick={onCloseButtonClick}>
            <img src={CLOSE_BTN} alt='close' />
          </button>
          <div className='title-modal'>
            <div className={`color-primary`}>{t(`${GUILD_MESSAGE}.donateToGuildVault`)}</div>
            <img src={TWO_LINE} alt='' />
          </div>
          <div className='content-modal'>
            <div className='row line__guild--gradiant'>
              <img src={LINE_GUILD_GRADIENT} />
            </div>
            <div className='container'>
              <div>
                <RaceTable
                  columns={memoizedResultListSelectionColumns}
                  isHasMore={false}
                  data={dataItems}
                  raisePage={setParams}
                  loader={!loading}
                  params={params}
                  checkLoadingPage={false}
                  totalRace={total}
                  currentUser={profile}
                  noDataText={t(`${NOTIFICATION_MESSAGE}.dataNotFound`)}
                  isShowVipIcon={true}
                  onClickOneCell={id => {
                    setTokenIds(prev => {
                      if (prev.includes(id)) {
                        return prev.filter(item => item !== id)
                      }
                      return [...prev, id]
                    })
                    const newItems = dataItems.map((it: any) =>
                      it.item_token === id ? { ...it, isSelected: !it.isSelected } : it
                    )
                    setDataItems(newItems)
                  }}
                />
              </div>
              <div className='pagination custom'>
                {dataItems.length > 0 && Number(total) > 10 && (
                  <div className='paginate'>
                    <ReactPaginate
                      nextLabel='>'
                      onPageChange={handlePageClick}
                      pageRangeDisplayed={3}
                      marginPagesDisplayed={2}
                      pageCount={Math.ceil(Number(total) / params.limit)}
                      previousLabel='<'
                      pageClassName='page-item'
                      pageLinkClassName='page-link'
                      previousClassName='page-item'
                      previousLinkClassName='page-link'
                      nextClassName='page-item'
                      nextLinkClassName='page-link'
                      breakLabel='...'
                      breakClassName='page-item'
                      breakLinkClassName='page-link'
                      containerClassName='pagination'
                      activeClassName='active'
                      forcePage={params.page ? +params.page - 1 : 0}
                    />
                  </div>
                )}
              </div>
            </div>
            <div className='actions-container'>
              <div className='balance-container'>
                <div className='donate'>
                  <div className='action'>
                    <Button
                      type='btnCancel'
                      buttonName={t(`${GUILD_MESSAGE}.cancel`)}
                      onClickButton={onCloseButtonClick}
                      width={147}
                    />
                    <Button
                      isLoading={loadingSubmit}
                      buttonName={t(`${GUILD_MESSAGE}.donate`)}
                      onClickButton={handleSave}
                      width={147}
                      disabled={!tokenIds?.length || tokenIds?.length > 20}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        {openInProgressBalanceModal && <InProgressBalanceModal title={'DONATE IN PROGRESS'} />}
        {isConfirm && (
          <ModalConfirm
            onClose={() => setIsConfirm(false)}
            onConfirm={handleConfirmSubmit}
            titleModal='Confirm Donation'
            loading={loadingSubmit}
            content={
              <>
                <div className='content-confirm'>
                  <div>You’re donating</div>
                  <div>
                    <img
                      className='mr-2'
                      alt='Merah'
                      src={dataItems.find((it: any) => it.item_token === tokenIds?.[0])?.img}
                      width='25px'
                      height='25px'
                      style={{ objectFit: 'contain' }}
                    />
                  </div>
                  <div>{dataItems.find((it: any) => it.item_token === tokenIds?.[0])?.name}</div>
                </div>
                <div>This can’t be undone.</div>
              </>
            }
            margingTop={true}
            widthM={550}
            heightM={250}
          />
        )}
        {isConfirmMulti && (
          <ModalConfirm
            onClose={() => setIsConfirmMulti(false)}
            onConfirm={handleConfirmSubmit}
            titleModal='Confirm Donation'
            loading={loadingSubmit}
            content={
              <>
                <div className='content-confirm'>
                  <div>You’re about to donate multiple items.</div>
                </div>
                <div>This can’t be undone.</div>
              </>
            }
            margingTop={true}
            widthM={550}
            heightM={250}
          />
        )}
      </ModalDonateNftStyled>
    </Modal>
  )
}
